import React from 'react';
import './WysiwygHtml.sass';

import cx from 'classnames';
import RawHtml from './RawHtml';

export default function WysiwygHtml({className, ...rest}) {
  return (
    <RawHtml className={cx('wysiwyg', className)} {...rest}/>
  );
}



// WEBPACK FOOTER //
// ./components/rawHtml/WysiwygHtml.js